import React, { useState, useEffect } from 'react';
import { uploadBuyAll, fetchPresignedUrl } from '../shared/api';

const BuyAllSlotCard = ({ buyAllS3Path, onBuyAllChange }) => {
  const [uploading, setUploading] = useState(false);
  const [previewUrl, setPreviewUrl] = useState(null);

  // Load presigned URL for the current buy_all image
  useEffect(() => {
    if (!buyAllS3Path) {
      setPreviewUrl(null);
      return;
    }
    fetchPresignedUrl(buyAllS3Path)
      .then(url => setPreviewUrl(url))
      .catch(() => setPreviewUrl(null));
  }, [buyAllS3Path]);

  const handleUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setUploading(true);
    try {
      const result = await uploadBuyAll(file);
      onBuyAllChange(result.s3_key);
    } catch (err) {
      alert('Upload failed: ' + (err.response?.data?.error || err.message));
    }
    setUploading(false);
    // Reset input so the same file can be re-uploaded
    e.target.value = '';
  };

  return (
    <div style={{
      flex: 1,
      border: '1px solid #e0e0e0',
      borderRadius: 6,
      background: '#fff',
      padding: 12,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      minHeight: 100,
      position: 'relative'
    }}>
      <div style={{ fontSize: 10, color: '#9c27b0', marginBottom: 6, fontWeight: 600 }}>
        Buy All Banner
      </div>

      {previewUrl ? (
        <div style={{ textAlign: 'center', width: '100%' }}>
          <div style={{
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            width: 120, height: 150, margin: '0 auto',
            borderRadius: 3, overflow: 'hidden', background: '#f0f0f0'
          }}>
            <img
              src={previewUrl}
              alt="Buy All Banner"
              style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }}
            />
          </div>
          <div style={{ fontSize: 10, color: '#666', marginTop: 4 }}>640 x 800</div>
          <div style={{ display: 'flex', gap: 4, marginTop: 4, justifyContent: 'center' }}>
            <label style={{
              fontSize: 10, padding: '2px 8px', background: '#e3f2fd',
              border: '1px solid #90caf9', borderRadius: 3, cursor: 'pointer'
            }}>
              Replace
              <input
                type="file"
                accept="image/jpeg,image/jpg,image/png"
                onChange={handleUpload}
                style={{ display: 'none' }}
              />
            </label>
            <button
              onClick={() => onBuyAllChange(null)}
              style={{
                fontSize: 10, padding: '2px 8px', background: '#ffebee',
                border: '1px solid #ef9a9a', borderRadius: 3, cursor: 'pointer'
              }}
            >
              Clear
            </button>
          </div>
        </div>
      ) : (
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: '100%', gap: 4 }}>
          <label style={{
            padding: '12px 16px', background: '#f3e5f5',
            border: '2px dashed #ce93d8',
            borderRadius: 4, cursor: uploading ? 'default' : 'pointer',
            fontSize: 12, color: '#7b1fa2', textAlign: 'center',
            width: '100%', boxSizing: 'border-box',
            opacity: uploading ? 0.6 : 1
          }}>
            {uploading ? 'Uploading...' : 'Upload Buy All Image'}
            <div style={{ fontSize: 10, color: '#9c27b0', marginTop: 2 }}>
              JPG — displays at 640x800
            </div>
            <input
              type="file"
              accept="image/jpeg,image/jpg,image/png"
              onChange={handleUpload}
              disabled={uploading}
              style={{ display: 'none' }}
            />
          </label>
        </div>
      )}
    </div>
  );
};

export default BuyAllSlotCard;
